import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=6c3b8935"
import script from "./EditCategory.js?vue&type=script&lang=js&external"
export * from "./EditCategory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports